<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center justify-start">
							<v-icon color="#959595" class="mr-2">mdi-information</v-icon>
							<p class="mb-0 font-weight-bold text-primary body-1">Nuevo Informe</p>
						</div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									small
									color="#959595"
									@click="$store.commit('reports/setConfirmNewReportModal', false)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</template>
							<span>Cerrar</span>
						</v-tooltip>
					</div>
				</v-card-title>
				<v-card-text class="pa-0">
          <div class="pb-4 px-8">
						<div class="mt-6" v-if="this.modalData && this.modalData.item_id && this.modalData.item_type">
							<!-- Contrato -->
							<p class="mb-0 font-weight-bold">¿Quieres crear un nuevo informe?</p>
							<p class="mb-1">Este informe se creará para "<b>{{ this.modalData.item_name }} ({{ this.itemTypeName }})</b>"</p>
							<p>Esta acción generará un nuevo informe, por favor confirma.</p>
							
							<v-select
								v-model="selectedPrefix"
								:items="filteredPrefixes"
								:loading="$store.state.budget.loadingBudgetPrefixes"
								:menu-props="{ top: true, offsetY: true }"
								item-text="name"
								item-value="id"
								label="Selecciona Tipo de Informe"
								class="custom-height-search custom-height-calendar my-4"
								outlined
								dense
								required
							>
								<template v-slot:no-data>
									<v-list-item>
										<v-list-item-content>
											<div class="d-flex flex-column align-center justify-center">
												<p class="mb-0 caption">No se han creado tipos de informe</p>
											</div>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>

							<div class="d-flex flex-row align-center justify-end mt-2">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="$store.commit('reports/setConfirmNewReportModal', false)"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<v-btn
									depressed
									color="#959595"
									:dark="selectedPrefix"
									:disabled="!selectedPrefix"
									:loading="loadingCreation"
									@click="confirmReportCreation"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Confirmar</p>
								</v-btn>
							</div>
						</div>
						<div class="mt-6" v-else>
							<!-- Contrato -->
							<!-- <p class="mb-2 font-weight-bold">Por favor selecciona Concepto del informe:</p>
							<v-btn-toggle
								v-model="formData.item_type"
								dense
								class="d-flex flex-row mb-3 custom-toggle-btns"
							>
								<v-btn value="crm" class="flex-grow-1"
									:color="formData.item_type == 'crm' ? '#FF1209':''">
									<p class="mb-0 caption font-weight-bold" :class="formData.item_type == 'crm' ? 'white--text':''">CRM / Visita Técnica</p>
								</v-btn>
								<v-btn value="preproject" class="flex-grow-1"
									:color="formData.item_type == 'preproject' ? '#FF1209':''">
									<p class="mb-0 caption font-weight-bold" :class="formData.item_type == 'preproject' ? 'white--text':''">PreProyecto</p>
								</v-btn>
								<v-btn value="project" class="flex-grow-1"
									:color="formData.item_type == 'project' ? '#FF1209':''">
									<p class="mb-0 caption font-weight-bold" :class="formData.item_type == 'project' ? 'white--text':''">Proyecto</p>
								</v-btn>
							</v-btn-toggle> -->
							
							<v-select
								v-model="selectedPrefix"
								:items="filteredPrefixes"
								:loading="$store.state.budget.loadingBudgetPrefixes"
								:menu-props="{ top: true, offsetY: true }"
								item-text="name"
								item-value="id"
								label="Selecciona Tipo de Informe"
								class="custom-height-search custom-height-calendar my-4"
								outlined
								dense
								required
							>
								<template v-slot:no-data>
									<v-list-item>
										<v-list-item-content>
											<div class="d-flex flex-column align-center justify-center">
												<p class="mb-0 caption">No se han creado tipos de informe</p>
											</div>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
							<div class="mb-2">
								<!-- <p class="mb-0 font-weight-bold">Por favor selecciona:</p> -->
								<p class="mb-0 caption" v-if="formData.item_type == 'crm'">Selecciona un CRM, Preproyecto o Proyecto para el cual generarás este informe</p>
							</div>
							<div>
								<v-autocomplete
									:key="autocompleteKey"
									ref="autocompleteInput"
									v-model="selectedItem"
									:items="companyProjects"
									:menu-props="{ bottom: true, offsetY: true }"
									:loading="loadingSearch"
									:search-input.sync="searchTerm"
									item-text="name"
									item-value="id"
									label="Buscar"
									class="flex-grow-0 mb-0"
									autocomplete="off"
									outlined
									dense
									required
									no-filter
									return-object
									hide-details
									no-data-text="Búsqueda sin resultados"
									:disabled="!selectedPrefix"
									@change="onItemSelected"
									:rules="requiredRule"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex">
													<div style="width: 200px">
														<div class="d-flex aling-center" style="gap: 5px;">
															<v-chip
																x-small
																dark
																:color="getItemTypeColor(data.item.item_type)"
																class="mb-1"
															>
																{{getItemType(data.item.item_type)}}
															</v-chip>
															<v-chip
																x-small
																dark
																v-if="data.item.schedule"
																color="grey"
																class="mb-1"
															>
																Visita Técnica
															</v-chip>
														</div>
														<p class="mb-0">
															<span class="font-weight-bold">{{data.item.project_line}} - {{data.item.name}}</span><br/>
															<span class="light-blue-text">
																<template v-if="data.item.project_type || data.item.district">
																	<b v-if="data.item.project_type">[{{data.item.project_type}}]</b>
																	<span v-if="data.item.project_type && data.item.district"> - </span>
																	<span v-if="data.item.district">{{data.item.district}}</span>
																</template>
																<template v-else>Sin datos</template>
															</span>
														</p>
													</div>
													<span>-</span>
													<p class="flex-grow-1 text-right ml-4 mb-0">
														<span class="font-weight-bold">{{data.item.client_name}}</span><br/>
														<span class="light-blue-text">{{data.item.client_email}}</span>
													</p>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<v-chip
											v-bind="data.attrs"
											:input-value="data.selected"
											close
											@click="data.select"
											@click:close="selectedItem = null"
											small
										>
											{{ data.item.name }}
										</v-chip>
									</template>
								</v-autocomplete>
								<p class="caption px-1">Busca por línea de proyecto (ej: LP123), nombre cliente, dirección o tipo de proyecto.</p>
							</div>
							
							<!-- <p class="mb-0 font-weight-bold" v-if="selectedItemReports && selectedItemReports.reports_count">Existen {{ selectedItemReports.reports_count }} informes para este elemento. Estarás creando el informe Nº {{ selectedItemReports.reports_count + 1}}.</p> -->
							<p>Esta acción generará un nuevo informe, por favor confirma para continuar.</p>
							<div class="d-flex flex-row align-center justify-end mt-2">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="closeModal"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<v-btn
									depressed
									dark
									color="#959595"
									@click="startConfirmCreation"
									:loading="loadingCreation"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Confirmar</p>
								</v-btn>
							</div>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
		<GeneralConfirmationModal :modalData="confirmationModal" :closeModal="modalConfirmation"/>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce'
import {createReport} from '@/helpers/api/reports'
import {getConversations} from '@/helpers/api/conversations'
import {getCompanyPreProjects} from '@/helpers/api/preprojects'
import {getCompanyProjects} from '@/helpers/api/projects'
import GeneralConfirmationModal from '@/components/Modals/General/GeneralConfirmationModal'

export default {
  name: 'ConfirmNewReportCreationModal',
	components: {GeneralConfirmationModal},
  data: () => ({
		indexModal: + new Date(),
		selectedItem: null,
		confirmationModal: null,
		loadingCreation: false,
		selectedPrefix: null,
		formData: {
			item_type: 'crm',
			item_id: null,
		},
		searchTerm: null,
		autocompleteKey: 0,
		pendingSearchTerm: null,
		conversations: [],
		preProjects: [],
		companyProjectsList: [],
		loadingConversations: false,
		loadingPreProjects: false,
		loadingProjects: false,
		currentSearchId: null,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		filteredPrefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes.filter((prefix) => {
				return prefix.type == 'report'
			})
		},
		selectedItemReports(){
			if(this.formData.item_type == 'crm'){
				const found = this.conversations.find((item) => {
					return this.selectedItem.id == item.id
				})
				return found
			}
			else if(this.formData.item_type == 'preproject'){
				const found = this.preProjects.find((item) => {
					return this.selectedItem.id == item.id
				})
				return found
			}
			else if(this.formData.item_type == 'project'){
				const found = this.companyProjectsList.find((item) => {
					return this.selectedItem.id == item.id
				})
				return found
			}
			return null
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		loadingSearch(){
			return this.loadingConversations || this.loadingPreProjects
		},
		companyProjects(){
			const allProjects = [];
			if(this.conversations){
				this.conversations.forEach((item) => {
					const client_name = this.getCrmUserName(item)
					const client_email = this.getCrmUserEmail(item)
					allProjects.push({
						id: item.id,
						name: item.project_info?.project_detail ?? 'Sin detalle',
						client_name,
						client_email,
						schedule: item.schedule,
						project_type: item.project_info?.project_type?.name ?? '',
						project: item.project_info?.project_detail,
						project_line: item.project_line_info ? 'LP' + item.project_line_info?.project_line?.number : '',
						address: item.project_info?.address?.address,
						district: item.project_info?.address?.district?.name,
						item_type: 'crm'
					})
				})
			}

			if(this.preProjects){
				this.preProjects.forEach((item) => {
					const client_name = this.getUserName(item)
					let schedule = null
					if(item.associations?.associations?.length){
						schedule = item.associations.associations.some(assoc => assoc.morphable?.schedule)
					}
					allProjects.push({
						id: item.id,
						name: item.name,
						client_name,
						client_email: item.client?.email,
						schedule,
						project_type: item.info?.project_type?.name ?? '',
						project: item.name,
						project_line: item.project_line_info ? 'LP' + item.project_line_info?.project_line?.number : '',
						address: item.info?.address?.address,
						district: item.info?.address?.district?.name,
						item_type: 'preproject'
					})
				})
			}

			if(this.companyProjectsList){
				this.companyProjectsList.forEach((item) => {
					const client_name = this.getUserName(item)
					allProjects.push({
						id: item.id,
						name: item.name,
						client_name,
						client_email: item.client?.email,
						project_type: item.info?.project_type?.name ?? '',
						project_line: item.project_line_info ? 'LP' + item.project_line_info?.project_line?.number : '',
						project: item.name,
						address: item.info?.address?.address,
						district: item.info?.address?.district?.name,
						item_type: 'project'
					})
				})
			}

			return allProjects
		},
		filteredCompanyProjects(){
			return this.companyProjects.filter(item => item.item_type === this.formData.item_type)
		},
		typeSelectionName(){
			if(this.formData.item_type == 'crm'){
				return 'Un CRM'
			}
			else if(this.formData.item_type == 'preproject'){
				return 'Un PreProyecto'
			}
			else if(this.formData.item_type == 'project'){
				return 'Un Proyecto'
			}
			else{
				return ''
			}
		},
		modalData() {
			return this.$store.state.reports.confirmNewReportModal
		},
		canShowModal() {
			return !!this.modalData
		},
		queryRoute(){
			return this.$route
		},
		itemTypeName(){
			switch (this.modalData.item_type) {
				case "crm":
					return 'CRM'
				case "preproject":
					return 'PreProyecto'
				case "project":
					return 'Proyecto'
				default:
					return ''
			}
		}
	},
	watch: {
		queryRoute(){
			this.closeModal()
		},
    searchTerm() {
			this.sendToSearch()
    },
		'formData.item_type'(newVal, oldVal) {
			if (newVal === oldVal) return;
			const savedTerm = this.searchTerm;
			this.autocompleteKey++;

			this.$nextTick(() => {
				this.$nextTick(() => {
					const input = this.$refs.autocompleteInput;
					if (!input) return;

					if (savedTerm && savedTerm.length) {
						input.lazySearch = savedTerm;
						this.searchTerm = savedTerm;
						input.isMenuActive = true;
						this.searchForTerm();
					}

					const nativeInput = input.$el.querySelector('input');
					if (nativeInput) {
						nativeInput.focus();
						const len = (savedTerm || '').length;
						nativeInput.setSelectionRange(len, len);
					}
				});
			});
		}
	},
  mounted(){
		let data = {
			start: 0,
			limit: 500
		}
		this.formData = {...this.formData, ...this.modalData}
		this.selectedItem = {...this.formData, ...this.modalData, ...{id: this.formData.item_id}}
		this.loadProjectsData(data)
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		getItemType(type){
			if(type == 'crm'){
				return 'CRM'
			}
			else if(type == 'preproject'){
				return 'PreProyecto'
			}
			else if(type == 'project'){
				return 'Proyecto'
			}
			else{
				return ''
			}
		},
		getItemTypeColor(type){
			if(type == 'crm'){
				return '#FF1209'
			}
			else if(type == 'preproject'){
				return 'orange'
			}
			else if(type == 'project'){
				return 'green'
			}
			else{
				return '#E5E9F2'
			}
		},
    closeModal(){
      this.$store.commit('reports/setConfirmNewReportModal', false)
    },
		async loadProjectsData(data) {
			const searchId = Date.now()
			this.currentSearchId = searchId
			
			const searchTermLower = (this.searchTerm || '').toLowerCase()
			const isCRMSearch = searchTermLower.includes('crm') || searchTermLower.includes('visita') || searchTermLower.includes('visita técnica') || searchTermLower.includes('visita tecnica')
			const isPreProjectSearch = searchTermLower.includes('preproyecto')
			const isProjectSearch = searchTermLower.includes('proyecto')
			
			const hasKeywordSearch = isCRMSearch || isPreProjectSearch || isProjectSearch
			const searchCRM = !hasKeywordSearch || isCRMSearch
			const searchPreProject = !hasKeywordSearch || isPreProjectSearch
			const searchProject = !hasKeywordSearch || isProjectSearch
			
			try {
				const requests = []
				
				if (searchCRM) {
					this.loadingConversations = true
					requests.push(
						getConversations(data).then(response => {
							if (this.currentSearchId === searchId && response?.code === 200) {
								this.conversations = response.conversations
							}
						}).finally(() => {
							if (this.currentSearchId === searchId) {
								this.loadingConversations = false
							}
						})
					)
				}
				else {
					this.conversations = []
				}
				
				if (searchPreProject) {
					this.loadingPreProjects = true
					requests.push(
						getCompanyPreProjects(data).then(response => {
							if (this.currentSearchId === searchId && response?.code === 200) {
								this.preProjects = response.preprojects
							}
						}).finally(() => {
							if (this.currentSearchId === searchId) {
								this.loadingPreProjects = false
							}
						})
					)
				}
				else {
					this.preProjects = []
				}

				if (searchProject) {
					this.loadingProjects = true
					requests.push(
						getCompanyProjects(data).then(response => {
							if (this.currentSearchId === searchId && response?.code === 200) {
								this.companyProjectsList = response.projects
							}
						}).finally(() => {
							if (this.currentSearchId === searchId) {
								this.loadingProjects = false
							}
						})
					)
				}
				else {
					this.companyProjectsList = []
				}
				
				await Promise.all(requests)
			} catch (error) {
				if (this.currentSearchId === searchId) {
					this.conversations = []
					this.preProjects = []
					this.companyProjectsList = []
					this.loadingConversations = false
					this.loadingPreProjects = false
					this.loadingProjects = false
				}
			}
		},
		onItemSelected() {
			this.$nextTick(() => {
				this.searchTerm = null
				let data = { start: 0, limit: 500 }
				this.loadProjectsData(data)
			});
		},
		getCrmUserName(item){
			let name = ''
			if(item.user && item.user.user && item.user.user.profile){
				name = item.user.user.profile.name + ' ' + item.user.user.profile.lastname + ' ' + item.user.user.profile.second_lastname
			}
			else if(item.user){
				name = item.user.name
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		getCrmUserEmail(item){
			let email = ''
			if(item.user && item.user.getCrmUserName){
				email = item.user.user.email
			}
			else if(item.user){
				email = item.user.email
			}
			else{
				email = 'No identificado'
			}
			return email
		},
		getUserName(item){
			let name = ''
			if(item.client && item.client.profile){
				name = item.client.profile.name + ' ' + item.client.profile.lastname + ' ' + item.client.profile.second_lastname
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		sendToSearch: _debounce(function() { this.searchForTerm() }, 800),
		async searchForTerm(){
			let data = {
				start: 0,
				limit: 500
			}
			if(this.searchTerm && this.searchTerm.length){
				data = {...data, ...{search: this.searchTerm}}
			}
			this.loadProjectsData(data)
		},
		startConfirmCreation(){
			if(this.selectedItemReports.reports_count){
				const modal_content = `${'<p class="mb-0 font-weight-bold">Existen ' + this.selectedItemReports.reports_count + ' informes para el elemento seleccionado.</p><p>Estarás creando el informe Nº ' + (this.selectedItemReports.reports_count + 1) }</p>`
				this.confirmationModal = {
					title: 'Ya hay informes para el elemento',
					modal_content,
					status: true
				}
				return null
			}
			this.confirmReportCreation()
		},
		modalConfirmation(confirm = false){
			this.confirmationModal = null
			if(confirm){
				this.confirmReportCreation()
			}
		},
		async confirmReportCreation() {
			this.loadingCreation = true
			const data = {
				...this.modalData,
				...this.formData,
				...{
					item_id: this.selectedItem.id,
					item_type: this.selectedItem.item_type,
					prefix_id: this.selectedPrefix
				}
			}
			const report = await createReport(data)
			this.loadingCreation = false
			if(report.code == 200){
				if(report.crm_no_vt){
					const messageData = {
						message: 'El informe no pudo ser creado ya que este elemento (CRM) no tiene una visita técnica asociada.',
						title: 'Sin Visita Técnica',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
					return null
				}
				if(report.has_opened_report){
					const source = report.report;
					if (source) {
						const dataInfo = {
							...source,
							doc_type: 3
						};
						this.$store.commit('general/setExistentDocumentNotificationModalData', dataInfo);
						this.$store.commit('general/setExistentDocumentNotificationModal', true);
					}
					this.$store.commit('reports/setConfirmNewReportModal', false)
					return
				}
				this.$router.push({ name: 'ReportDetail', query: { id: report.report.id } })
				this.$store.commit('reports/setConfirmNewReportModal', false)
				//Cierra posible iniciador
				this.$store.commit('userrequests/setUserRequestModalId', null)
			}
			else{
				const messageData = {
					message: 'Error al crear el informe, por favor intenta nuevamente.',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>